export default __webpack_public_path__ + "static/media/coin1.8709bc61.png";